module.exports = __webpack_public_path__ + "img/the-path-to-unity.e1bef137.png";